import project1 from "./../img/projects/01.jpg";
import project1Big from "./../img/projects/01-big.jpg";

import project2 from "./../img/projects/02.jpg"
import project2Big from "./../img/projects/02-big.jpg";

import project3 from "./../img/projects/03.jpg"
import project3Big from "./../img/projects/03-big.jpg";

import project4 from "./../img/projects/04.jpg"
import project4Big from "./../img/projects/04-big.jpg";

import project5 from "./../img/projects/05.jpg"
import project5Big from "./../img/projects/05-big.jpg";

import project6 from "./../img/projects/06.jpg"
import project6Big from "./../img/projects/06-big.jpg";

const projects = [
  {
    title: 'Responsive website',
    skills: 'HTML, CSS, SASS, JavaScript',
    img: project1,
    imgBig: project1Big,
    websiteLink: 'https://www.auramus.fi/',
    description: 'Development of the project from scratch, including design, implementation, and programming. Website development and configuration, creating responsive design.',
  },

  {
    title: 'Layout with parallax effect',
    skills: 'HTML, CSS, SASS, JavaScript',
    img: project2,
    imgBig: project2Big,
    gitHubLink: 'https://github.com/maikamp-ven/layout_with_parallax.git',
  },

  {
    title: 'Responsive website',
    skills: 'HTML, CSS, JavaScript and Photoshop',
    img: project3,
    imgBig: project3Big,
  },

  {
    title: 'Multi-page website',
    skills: 'HTML, CSS, JavaScript, PHP, WordPress, SQL',
    img: project4,
    imgBig: project4Big,
    websiteLink: 'https://moveyou.fi/',
    description: 'Development of the project from scratch, including design, implementation, and programming. All photos used in the project were also taken by me. Website development and configuration, creating responsive design, and CMS WordPress integration.',
  },

  {
    title: 'Responsive space website',
    skills: 'HTML, CSS, JavaScript',
    img: project5,
    imgBig: project5Big,
    gitHubLink: 'https://github.com/maikamp-ven/responsive-space-web.git',
  },

  {
    title: 'A lot of small projects',
    skills: 'HTML, CSS, JavaScript',
    img: project6,
    imgBig: project6Big,
    description: 'Many small projects are represented, such as: Slider 3d effect, Responsive card slider project, Multi Step Form With Progress, Navigation Menu Indicator, 3d wave slider, Neumorphic Form. ',
  },
]
 
export {projects}